import { render, staticRenderFns } from "./AdvertisingStatistic.vue?vue&type=template&id=ddd6ab2e&scoped=true"
import script from "./AdvertisingStatistic.vue?vue&type=script&lang=js"
export * from "./AdvertisingStatistic.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingStatistic.vue?vue&type=style&index=0&id=ddd6ab2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd6ab2e",
  null
  
)

export default component.exports